import React from 'react';
import { FaCircleNotch } from 'react-icons/fa';

import './ElementAnimation.scss';

const ElementLoadAnimation = () => {
  return <FaCircleNotch className="element-load-animation" />
}

export default ElementLoadAnimation;